import { Component, OnInit } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { CleverTapConstents, ConstantData, LoanStatusConstant } from 'src/app/services/constants';
import { DialogBoxService } from 'src/app/services/dialog-box.service';
import { TenureDetails } from 'src/app/services/model';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-eligibility',
  templateUrl: './eligibility.component.html',
  styleUrls: ['./eligibility.component.scss']
})
export class EligibilityComponent implements OnInit {
  options: AnimationOptions = {
    path: this.util.redirectionUrl + ConstantData.compassLoader,
  }
  timerCount: number = 5;
  timer: any;
  bankDetailsCalled: boolean = false;
  status: any = {
    isEligiblity: true,
    isTermLoan: false,
    success: false,
    isRejected: false,
    iswaiting: false,
    isMorotorium: false,
    aa: false,
  }
  formator = new Intl.NumberFormat('en-US',);
  aa: any;
  elTimer: any;
  showDialog: boolean = false;
  tenureData: TenureDetails[] = [];
  selectedTenure!: TenureDetails;
  isAutomatic: boolean = false;
  warnImage = ConstantData.warnImage;
  successOption: AnimationOptions = {
    path: this.util.redirectionUrl + ConstantData.successLoan,
  };
  constructor(public util: UtilService, private dialog: DialogBoxService) { }

  ngOnInit(): void {
    this.dialog.eligibilityDialogState.subscribe((show: any) => {
      if (show) {
        this.selectedTenure = this.util.getCache('selectedTenure');
        if (this.selectedTenure) {
          this.status = { success: true };
          this.util.getProducts().then(() => {
            setTimeout(() => {
              this.util.setCache('selectedTenure', null);
              this.nextScreen();
            }, 2000);
          });

        }
        else
          this.initEl();

      }

      this.isAutomatic = false;
      this.showDialog = show;
    });
  }
  initEl(): void {

    this.timerCount = 5;
    this.bankDetailsCalled = false;
    this.status = {
      isEligiblity: true,
      isTermLoan: false,
      success: false,
      isRejected: false,
      iswaiting: false,
      aa: false,
    };


    this.timer = setInterval(() => {
       this.processing();
    }, 5000);
    this.processing();
  }

  processing(){
    this.util.getProducts(undefined,false);
    const loanDetails = this.util.loanDetails;
      this.timerCount = +5;
      if (this.timerCount >= 60) {
        this.status = { iswaiting: true };
      }
      if (loanDetails.submittedForLevel1) {
        if (loanDetails.statusId === LoanStatusConstant.rejected) {
          this.status = { isRejected: true };
          clearInterval(this.timer);
          return;
        }
        switch (loanDetails.loanEligibilityLevel) {
          // Level 1 check
          case 'level1':
            {

              switch (loanDetails.loanEligibilityStatusV2) {
                case LoanStatusConstant.processing: // processing
                  return;
                case LoanStatusConstant.completed: // completed
                  this.getCommercialDetails();
                  clearInterval(this.timer);
                  return;
                case LoanStatusConstant.failed:  // failed
                  if (loanDetails.statusId === LoanStatusConstant.rejected) {
                    this.status = { isRejected: true };
                  } else {
                    this.status = { aa: true };
                    setTimeout(() => {
                      this.showDialog = false;

                    }, 5000)
                    setTimeout(() => {
                      this.util.navigationHandler();
                    }, 500);
                  }
                  clearInterval(this.timer);
                  return;
              }
            }
            break;
          case 'level2': {
            switch (loanDetails.loanEligibilityStatusV2) {
              case LoanStatusConstant.processing:
                return;
              case LoanStatusConstant.completed:
                if (loanDetails.statusId === LoanStatusConstant.rejected) {
                  this.status = { isRejected: true };
                } else {
                  this.getCommercialDetails();
                }
                clearInterval(this.timer);
            }
          }
            break;
        }
      }
     
  }

  getProducts() {
    return this.util.getProducts(undefined, false);
  }


  getCommercialDetails() {
    const loanData = this.util.loanDetails;
    if (
      loanData.statusId == LoanStatusConstant.rejected
    ) {
      this.status = { isRejected: true };
    } else {
      this.status = { isTermLoan: true };
      this.clearTimer();
    }

    if (loanData.loanCommercialDetails != null) {
      this.tenureData = this.util.getTenureDetails();
    }


  }

  goToHome() {
    if (this.status.aa || this.isAutomatic) {
      return;
    }

    this.util.route('home');
  }


  selectTerm(terms: (TenureDetails | Boolean)) {
    let term!: TenureDetails;
    if (typeof terms === 'boolean') {
      this.showDialog = false;
      return;
    }
    term = <TenureDetails>terms;
    const loanDetails = this.util.loanDetails;
    if (loanDetails.hasMoratorium) {
      this.selectedTenure = term;
      this.util.setCache('selectedTenure', this.selectedTenure);
      this.util.route('moratorium');
      this.isAutomatic = true;
      this.showDialog = false;

    } else {
      this.selectedTenure = term;
      this.util.updateCommercials(this.selectedTenure).then(() => {
        this.util.getProducts().then(() => {
          this.status = { success: true };

          setTimeout(() => {
            this.nextScreen();
          }, 2000);
        })

      }).catch(() => {
        this.showDialog = false;
        this.util.getToken('');

      })
    }
  }

  nextScreen() {
    const loanDetails = this.util.loanDetails;
    this.isAutomatic = true;
    if (loanDetails.statusId === LoanStatusConstant.rejected) {
      this.showDialog = false;

      this.util.getToken('');
      return;
    }
    this.showDialog = false;
    setTimeout(() => {
      this.util.navigationHandler();
      this.clearTimer();
    }, 500);

  }

  clearTimer() {
    if (this.elTimer) {
      clearInterval(this.elTimer);
    }
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  discardLoan() {
    this.util.route('home');
    this.util.cleverTapEventCall(CleverTapConstents.discard_application, {
      'loanId': this.util.loanDetails.loanId,
      'productCode': this.util.loanDetails.productCategory,
      'totalFees': this.util.loanDetails!.institutionInfo?.amount ?? 'NA',
      'tenureMonths': this.util.loanDetails!.institutionInfo?.tenorMonths ?? 'NA'
    });
    this.util.discardLoan(() => {
      this.showDialog = false;
    })
  }
}
